const mediaItems = [
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20movie%20trailer%20moment%20with%20heroic%20silhouette%20against%20sunset%2C%20dramatic%20orange%20sky%2C%20cinematic%20widescreen%20composition%2C%20emotional%20and%20powerful%20atmosphere%2C%20film%20grain%20texture&width=640&height=360&seq=media-trailer-01&orientation=landscape',
    title: '《流浪地球3》终极预告发布',
    type: '预告片',
    duration: '2:35',
    views: '128万次播放',
    time: '3小时前',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20with%20camera%20crew%20on%20set%2C%20professional%20lighting%20equipment%2C%20warm%20studio%20atmosphere%2C%20cinematic%20workplace%2C%20creative%20energy&width=640&height=360&seq=media-bts-02&orientation=landscape',
    title: '《封神第二部》幕后花絮独家曝光',
    type: '花絮',
    duration: '5:12',
    views: '96万次播放',
    time: '昨天',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Film%20critic%20review%20scene%20with%20movie%20posters%20on%20wall%2C%20warm%20desk%20lamp%20lighting%2C%20cozy%20study%20atmosphere%2C%20intellectual%20vibe%2C%20books%20and%20notes%2C%20thoughtful%20composition&width=640&height=360&seq=media-review-03&orientation=landscape',
    title: '深度解析：今年最好的十部文艺片',
    type: '影评',
    duration: '12:48',
    views: '73万次播放',
    time: '2天前',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Actor%20interview%20setting%20with%20soft%20studio%20lighting%2C%20comfortable%20chair%2C%20warm%20atmosphere%2C%20professional%20video%20production%20setup%2C%20intimate%20portrait%20style%2C%20elegant%20backdrop&width=640&height=360&seq=media-interview-04&orientation=landscape',
    title: '年度演员专访：表演是一种修行',
    type: '专访',
    duration: '18:20',
    views: '65万次播放',
    time: '3天前',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Top%20ten%20movie%20countdown%20visual%20with%20dramatic%20red%20velvet%20background%2C%20golden%20numbers%2C%20cinematic%20prestige%20aesthetic%2C%20luxurious%20theater%20atmosphere%2C%20glamorous%20spotlight%20effects&width=640&height=360&seq=media-top10-05&orientation=landscape',
    title: '快看影视用户票选年度十佳电影',
    type: '榜单',
    duration: '8:15',
    views: '156万次播放',
    time: '5天前',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              影视快讯
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              最新预告、幕后花絮与深度影评一网打尽
            </p>
          </div>

          <div className="space-y-4">
            {mediaItems.map((item, i) => (
              <a
                key={i}
                href="#media"
                onClick={(e) => e.preventDefault()}
                className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer"
              >
                <div className="relative flex-shrink-0 w-full sm:w-56 aspect-video sm:aspect-auto sm:h-32 rounded-lg overflow-hidden">
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    title={`快看影视 - ${item.title}`}
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/85 backdrop-blur-sm group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-white text-lg ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 backdrop-blur-sm text-white text-xs">
                    {item.duration}
                  </div>
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="px-2 py-0.5 rounded-md bg-primary-50 text-primary-700 text-xs font-medium">
                      {item.type}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span><i className="ri-eye-line mr-1"></i>{item.views}</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}